module.exports = __webpack_public_path__ + "static/media/IF.0ae4d30b.svg";